<template>
    <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import chartResize from './mixins/chart-resize';
export default {
    mixins: [chartResize],
    props: {
        className: {
            type: String,
            default: 'echarts'
        },
        unitText: {
            type: String,
            default: ''
        },
        yText: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: '100%'
        },
        height: {
            type: String,
            default: '100%'
        },
        autoResize: {
            type: Boolean,
            default: true
        },
        chartData: {
            type: Object,
            default: () => ({}),
            required: true
        }
    },
    watch: {
        chartData: {
            deep: true,
            handler(chartData) {
                this.$nextTick(() => {
                    this.setOptions(chartData);
                });
            }
        }
    },
    data() {
        return {
            chart: null
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart();
        });
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart.dispose();
        this.chart = null;
    },
    methods: {
        initChart() {
            this.chart = this.$echarts.init(this.$el, 'macarons');
            this.setOptions(this.chartData);
        },
        setOptions(query) {
            if (query.data.length === 0) {
                this.chart._dom.innerHTML = '-暂无相关数据-';
                this.chart._dom.style.cssText = 'text-align:center; color:#999; border: none;line-height: 300px';
                this.chart._dom.removeAttribute('_echarts_instance_');
                return;
            }
            let valMax = 0,
                valMin = 0;
            if (query.rangeData.length > 0) {
                valMax = Math.max.apply(
                    Math,
                    query.rangeData.flat().map(item => item.yAxis)
                );
                valMin = Math.min.apply(
                    Math,
                    query.rangeData.flat().map(item => item.yAxis)
                );
            }
            let option = {
                title: {
                    text: this.$t('text.HistoricalDataLineChart'),
                    top: '20',
                    left: 'center',
                    color: 'var(--primary-color)'
                },
                // 图表位置
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '10%'
                },
                // 拐点提示窗
                tooltip: {
                    trigger: 'axis',
                    formatter: params => {
                        params = params[0];
                        let date = new Date(params.name);
                        return (
                            $t('public.time') +
                            ':' +
                            date.getFullYear() +
                            '-' +
                            (date.getMonth() + 1) +
                            '-' +
                            date.getDate() +
                            ' ' +
                            date.getHours() +
                            ':' +
                            date.getMinutes() +
                            ':' +
                            date.getSeconds() +
                            `<br>` +
                            `${$t('device.current_probe_value')}: ${params.value[1]}${this.unitText}` +
                            `<br>` +
                            `${$t('integration.monitoring_interval')}: ${params.data.min || ''}${this.unitText} - ${params.data.max || ''}${this.unitText}`
                        );
                    }
                },
                animation: false,
                xAxis: {
                    type: 'time'
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    // min: -100,
                    // max: 100,
                    min: function (value) {
                        if (valMin <= 0 && value.min < 0) {
                            return valMin < value.min ? valMin : value.min;
                        } else if (valMin > 0 && value.min > 0) {
                            return 0;
                        } else if (valMin < 0 && value.min > 0) {
                            return valMin || 0;
                        } else if (valMin >= 0 && value.min < 0) {
                            return value.min || 0;
                        } else {
                            return 0;
                        }
                    },
                    max: function (value) {
                        return valMax > value.max ? valMax : value.max;
                    },
                    name: this.yText,
                    axisLine: {
                        lineStyle: {
                            color: 'var(--primary-color)',
                            width: 1.8
                        }
                    }
                },
                series: [
                    {
                        data: query.data,
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        // name: $t('integration.line_chart'),
                        markPoint: {
                            data: [
                                { type: 'max', name: 'Max' },
                                { type: 'min', name: 'Min' }
                            ]
                        },
                        markArea: {
                            itemStyle: {
                                color: 'var(--primary-color)',
                                opacity: 0.3
                            },
                            data: query.rangeData || []
                        }
                    }
                ]
            };
            this.chart.setOption(option);
            // this.chart.appendData({
            //     seriesIndex: 0,
            //     data: query.data
            // })
        }
    }
};
</script>

<style></style>
